import { LucideIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SocialButtonProps {
  href: string;
  icon: LucideIcon;
  label: string;
  tooltip: string;
  className?: string;
}

export const SocialButton = ({
  href,
  icon: Icon,
  label,
  tooltip,
  className = "bg-blue-600 hover:bg-blue-700",
}: SocialButtonProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center justify-center gap-2 px-4 py-3 text-white rounded-lg transition-all duration-300 hover:scale-105 ${className}`}
          >
            <Icon className="w-5 h-5" />
            <span className="text-sm font-medium">{label}</span>
          </a>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};